import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, Typography } from '@material-ui/core'; 
import { ROUTE_HOME } from '../../routes/constants';
import i18n from '../../i18n';

class AppTitleLink extends Component {
  render() {
    return (
      <Tooltip title={<Typography>{i18n.t('toDashboard')}</Typography>}>
        <Link className='appLink' to={ROUTE_HOME}>{i18n.t('appTitle')}</Link>
      </Tooltip>
    )
  }
}

export default AppTitleLink;
